export default "__VITE_ASSET__Bng7b_wx__"